export default {
  GET_ITEMS(state) {
    return state.demandes
  },

  GET_ITEM(state, id) {
    return state.demandes.find(item => item.id == id)
  },
}
